<template>
  <basic-container>
    <div class="dynamic-journal-container">
      <div class="banner_w3lspvt-2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" aria-current="page">
            {{ $t("djif.title") }}
          </li>
        </ol>
      </div>
      <div style="height: 400px; text-align: center; background-color: #fff">
        <el-empty src="@/assets/images/noData.png" alt="" :description="$t('djif.description')"></el-empty>
      </div>
    </div>
  </basic-container>
</template>

<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
